import React, { useState, useMemo } from 'react';
import { Table, Input } from 'antd';

const ItemTable = ({ onAdd, onRemove, selectedItems, sectors = [], industries = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Combine sectors and industries into a single array for the table
  const combinedData = useMemo(() => {
    return [...sectors.map(name => ({ name, type: 'sector' })),
            ...industries.map(name => ({ name, type: 'industry' }))];
  }, [sectors, industries]);

  // Filter data based on search term
  const filteredData = combinedData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Define columns for the Ant Design table
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  // Handle row selection change
  const onRowClick = (record) => {
    const isSelected = selectedItems[record.type] && selectedItems[record.type].includes(record.name);
    if (isSelected) {
      onRemove(record.type, record.name);
    } else {
      onAdd(record.type, record.name);
    }
  };

  // Table row selection configuration
  const rowSelection = {
    onSelect: (record) => onRowClick(record),
    selectedRowKeys: combinedData.filter(item => selectedItems[item.type]?.includes(item.name)).map(item => item.name),
    getCheckboxProps: record => ({
      style: { display: 'none' }, // Hide checkboxes but keep the functionality
    }),
  };

  return (
    <div style={{maxWidth: '700px', margin: 'auto'}}>
      <Input
        placeholder="Search sectors/industries"
        onChange={e => setSearchTerm(e.target.value)}
        value={searchTerm}
        style={{ marginBottom: 20 }}
      />
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="name"
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        rowSelection={rowSelection}
        pagination={false} // Depending on your preference
      />
    </div>
  );
};

export default ItemTable;
